import React, { useContext, useRef } from 'react';
import { useQuery } from 'react-query';
import moment from 'moment';
import { FirebaseContext } from '../../../context/FirebaseContext';
import { getQuestionnair, getAditionalStatiData } from '../../../NecttosComp/APICaller/ApiServices';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import SettupQuestionnaire from './SettupQuestionnaire';
import AnalysisQuestionnaire from './AnalysisQuestionnaire';
import NewQuestionnaire from './NewQuestionnaire';
import { FeedbackStatistics } from './FeedBackStatistics';
import { Body, Header, Main } from '../../../NecttosComp/Layout/Layout';
import Button from '../../../NecttosComp/Button/Button';
import Input2 from '../../../NecttosComp/Input/Input2';
import { useTheme } from '../../../context/ThemeContext.js.js';
import Instruction from '../../../Documentation/Instruction';

export const FeedBackDashBoard = ({ onClose }) => {
	const { collegeId } = useContext(FirebaseContext);
	const { theme } = useTheme();
	const [questionair, setQuestionaire] = React.useState({ mainQ: 1 });
	const [state, setState] = React.useState({
		filterValue: '',
		page: 0,
		filterType: '',
		searchValue: '',
	});
	const componentRef = useRef();
	const [items, setItems] = React.useState({ addBook: false });
	const [audienceFilter, setAudienceFilter] = React.useState('');

	const { data: getAditionalStati = {} } = useQuery(['getAditionalStatiData', items.itemData], getAditionalStatiData({ collegeId, collection: 'users', stateData: items.itemData || {} }), { enabled: !!items.showWhoFill });

	const { data = [], refetch } = useQuery(['getQuestionnair', collegeId, state.filterType, state.searchValue], getQuestionnair(collegeId, state.filterType), { keepPreviousData: true });
	const filterTypeDrops = ['Student', 'Teacher', 'Staff'];

	const filteredData = data?.filter((item) => item?.title?.toLowerCase().includes(state.searchValue?.toLowerCase() || ''));

	const saveTargetAudience = async () => {
		let selectedClassArray = [];
		const catogoryDatas = Object.keys(items.itemData).map((key) => ({
			type: String(key).slice(0, 2),
			category: String(key).slice(2),
			value: items.itemData[key],
		}));
		catogoryDatas.forEach((item) => {
			if (item.type === '~l' && item.value) selectedClassArray.push(item.category);
		});
		try {
			const instance = await getAxiosTokenInstance();
			const res = await instance.post('/college/iqac/postQuestionnair', {
				collegeId,
				title: items.itemData.title,
				effectFrom: items.itemData.effectFrom,
				type: items.itemData.type,
				from: items.itemData.from,
				mode: items.itemData.mode,
				semester: items.itemData.semester,
				academicYear: items.itemData.academicYear,
				nature: items.itemData.nature,
				lastDate: items.itemData.lastDate,
				_id: items.questionnaireId,
				whoFill: selectedClassArray,
			});
			if (res.data.statusCode !== 200) throw new Error(res.data.message);
			refetch();
			setItems({ ...items, showWhoFill: false });
		} catch (err) {
			alert(err.message || 'Failed to save');
		}
	};

	const loadOldData = async (itemData) => {
		let newData = {};
		newData.mainQ = parseInt(itemData.itemData?.questionnaire?.length) || 1;
		itemData.itemData?.questionnaire?.forEach((item, c) => {
			newData[c + '~question'] = item.question;
			newData[c + 'subQ'] = parseInt(item?.subQuestions?.length) || 1;
			item?.subQuestions?.forEach((data, i) => {
				newData[c + '' + (i + '') + '~subQuestion'] = data.subQuestion;
				newData[c + '' + (i + '') + '~type'] = data.type;
				newData[c + '' + (i + '') + '~nature'] = data.nature;
				if (data.type === 'Options') {
					newData[c + '' + (i + '') + '~option1'] = data.option1;
					newData[c + '' + (i + '') + '~option2'] = data.option2;
					newData[c + '' + (i + '') + '~option3'] = data.option3;
					newData[c + '' + (i + '') + '~option4'] = data.option4;
					newData[c + '' + (i + '') + '~option5'] = data.option5;
				}
				if (data.type === 'Likert Scale') {
					newData[c + '' + (i + '') + '~likert1'] = data.likert1;
					newData[c + '' + (i + '') + '~likert5'] = data.likert5;
				}
			});
		});
		setQuestionaire(newData);
	};

	return (
		<Main title='Feed Back Form' height='100%' width='100%'>
			<Header>
				<div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 w-full'>
					<div className='flex flex-col sm:flex-row gap-4 w-full sm:w-auto flex-1'>
						<Input2 className='w-full sm:w-[48%] md:w-[400px] text-gray-900 dark:text-gray-300' options={filterTypeDrops} fieldName='Select Type *' setState={setState} state={state} returnKey='filterType' type='drop' />
						<Input2 className='w-full sm:w-[48%] md:w-[400px] text-gray-900 dark:text-gray-300' fieldName='Search Title *' setState={setState} state={state} returnKey='searchValue' type='text' />
					</div>
					<div className='flex flex-row flex-wrap gap-2 w-full sm:w-auto justify-start sm:justify-end'>
						<Button
							className='w-auto'
							type='refresh'
							onClick={() =>
								setItems({
									...items,
									newQuestionnaire: true,
									itemData: {},
									questionnaireId: undefined,
								})
							}>
							New
						</Button>
						<Button className='w-auto' type='print' tableRef={componentRef.current}>
							Print
						</Button>
						<Instruction keyId={'feedBackReports'}/>
						<Button className='w-auto' type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</div>
			</Header>

			<Body height='100%'>
				<div className={`min-h-[90%] px-4 py-6 sm:px-6 md:px-10 overflow-auto ${theme === 'dark' ? 'bg-gray-900 text-[#ffffffe2]' : ' text-gray-800'}`}>
					<div ref={componentRef} className='printable'>
						<div className='flex flex-wrap gap-4 justify-start'>
							{filteredData?.map((item, i) => (
								<div key={item._id} className={`w-full md:w-[48%] shadow-md rounded-2xl p-4 sm:p-6 flex flex-col gap-4 ${theme === 'dark' ? 'bg-gray-800 text-[#ffffffe2]' : 'bg-white text-gray-800'}`}>
									<div className='flex flex-col lg:flex-row justify-between gap-4'>
										<div className={`flex flex-col gap-3 p-4 rounded-xl shadow-md border w-full  ${theme === 'dark' ? 'bg-gray-700 text-[#ffffffe2] border-gray-600' : 'bg-white text-gray-800 border-slate-300'}`}>
											<div className='flex justify-between items-center'>
												<h3 className='text-xl sm:text-2xl font-bold text-gray-800 dark:text-[#ffffffe2]'>{`${parseInt(state.page) * 50 + 1 + i}. ${item.title}`}</h3>
											</div>

											<div className='flex flex-col gap-2 mt-2 text-sm text-gray-800 dark:text-white/90'>
												<div className='flex items-center'>
													<span className='font-medium w-28'>Duration:</span>
													<div className='flex-1 px-3 py-1 rounded-md shadow-sm bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 transition-colors'>{`From: ${moment(item.effectFrom).format('DD MMM YYYY')} — To: ${moment(item.lastDate).format('DD MMM YYYY')}`}</div>
												</div>
												<div className='flex items-center'>
													<span className='font-medium w-28'>Questions:</span>
													<div className='flex-1 px-3 py-1 rounded-md shadow-sm bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 transition-colors'>{`No of Questions: ${item.length}`}</div>
												</div>
												<div className='flex items-center'>
													<span className='font-medium w-28'>Type:</span>
													<div className='flex-1 px-3 py-1 rounded-md shadow-sm bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 transition-colors'>{item.type}</div>
												</div>
												<div className='flex items-center'>
													<span className='font-medium w-28'>Nature:</span>
													<div className='flex-1 px-3 py-1 rounded-md shadow-sm bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 transition-colors'>{item.nature}</div>
												</div>
											</div>
										</div>

										<div className='flex flex-col gap-2 w-full sm:w-[60%] lg:w-[30%]'>
											<Button type='edit' width='100%' onClick={() => setItems({ ...items, newQuestionnaire: true, questionnaireId: item._id, itemData: { ...item, effectFrom: moment(item.effectFrom).format('YYYY-MM-DD'), lastDate: moment(item.lastDate).format('YYYY-MM-DD') } })}>
												Edit Basics
											</Button>
											<Button
												type='fetch'
												width='100%'
												onClick={() => {
													const whoFillMap = {};
													item?.whoFill?.forEach((id) => {
														whoFillMap[`~l${id}`] = true;
													});

													setItems({
														...items,
														showWhoFill: true,
														questionnaireId: item._id,
														itemData: {
															...item,
															...whoFillMap,
														},
													});
												}}>
												Area of Survey
											</Button>

											<Button
												type='save'
												width='100%'
												onClick={async () => {
													setItems({ ...items, settupQuestionnaire: true, questionnaireId: item._id, itemData: { ...item, effectFrom: moment(item.effectFrom).format('YYYY-MM-DD'), lastDate: moment(item.lastDate).format('YYYY-MM-DD') } });
													await loadOldData({ ...items, settupQuestionnaire: true, questionnaireId: item._id, itemData: { ...item, effectFrom: moment(item.effectFrom).format('YYYY-MM-DD'), lastDate: moment(item.lastDate).format('YYYY-MM-DD') } });
												}}>
												Add Questions
											</Button>
											<Button type='refresh' width='100%' onClick={() => setItems({ ...items, questionnaireAnalysis: true, questionnaireId: item._id, itemData: item })}>
												Analysis
											</Button>
											<Button type='search' width='100%' onClick={() => setItems({ ...items, statistics: true, questionnaireId: item._id, itemData: item })}>
												Frequency
											</Button>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</Body>

			{items.newQuestionnaire && <NewQuestionnaire onCloseModal={() => setItems({ ...items, newQuestionnaire: false })} itemData={items.itemData} refectOrgin={refetch} questionnaireId={items.questionnaireId} onSuccess={() => setItems({ ...items, newQuestionnaire: false })} />}
			{items.settupQuestionnaire && <SettupQuestionnaire setState={setQuestionaire} state={questionair} onCloseModal={() => setItems({ ...items, settupQuestionnaire: false })} itemData={items.itemData} refectOrgin={refetch} questionnaireId={items.questionnaireId} onSuccess={() => setItems({ ...items, settupQuestionnaire: false })} />}
			{items.questionnaireAnalysis && <AnalysisQuestionnaire onCloseModal={() => setItems({ ...items, questionnaireAnalysis: false })} itemData={items.itemData} refectOrgin={refetch} questionnaireId={items.questionnaireId} onSuccess={() => setItems({ ...items, questionnaireAnalysis: false })} />}
			{items.statistics && <FeedbackStatistics onClose={() => setItems({ ...items, statistics: false })} itemData={items.itemData} refectOrgin={refetch} questionnaireId={items.questionnaireId} onSuccess={() => setItems({ ...items, statistics: false })} />}

			{items?.showWhoFill && (
				<Main height='100%' width='100%' title='Target Audience'>
					<div className={`h-full w-full p-6 rounded-2xl shadow-lg flex flex-col space-y-6 ${theme === 'dark' ? 'bg-gray-800 border border-gray-700 text-white' : 'bg-white border border-gray-200 text-gray-800'}`}>
						<div className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-b pb-4 ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'}`}>
							<Input2 type='text' fieldName='Search Department Name' returnKey='audienceFilter' state={{ audienceFilter }} setState={({ audienceFilter }) => setAudienceFilter(audienceFilter)} className='w-full sm:w-auto flex-1' />
							<Button type='close' onClick={() => setItems({ ...items, showWhoFill: false })}>
								Close
							</Button>
						</div>

						<div className='flex-1 overflow-y-auto space-y-6'>
							{['department', 'batches', 'classes'].map((key) => (
								<div key={key} className='space-y-3'>
									<h4 className={`text-md font-semibold ${theme === 'dark' ? 'text-white' : 'text-gray-700'}`}>
										{key === 'department' && 'Target Departments'}
										{key === 'batches' && 'Target Batches'}
										{key === 'classes' && 'Target Classes'}
									</h4>
									<div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
										{getAditionalStati?.[key]
											?.filter((item) => {
												if (key === 'department') {
													return item.name.toLowerCase().includes(audienceFilter?.toLowerCase() || '');
												}
												return true;
											})
											.map((item) => {
												const fieldKey = (key === 'classes' ? '~l' : key[0]) + item._id;
												return (
													<label key={item._id} className={`flex items-center gap-2 text-sm ${theme === 'dark' ? 'text-white/90' : 'text-gray-700'}`}>
														<input
															type='checkbox'
															className='h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500'
															checked={!!items.itemData?.[fieldKey]}
															onChange={() => {
																const newItemData = {
																	...items.itemData,
																	[fieldKey]: !items.itemData?.[fieldKey],
																};
																setItems({ ...items, itemData: newItemData });
															}}
														/>
														{item.name}
													</label>
												);
											})}
									</div>
								</div>
							))}
						</div>

						<div className={`pt-4 flex justify-end ${theme === 'dark' ? 'border-t border-gray-700' : 'border-t border-gray-200'}`}>
							<Button type='save' className='w-full sm:w-auto' onClick={saveTargetAudience}>
								Save Target Audience
							</Button>
						</div>
					</div>
				</Main>
			)}
		</Main>
	);
};
